import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import EmployeeList from './components/EmployeeList';
import AttendanceList from './components/AttendanceList';

function App() {
  return (
    <Router>
      <div style={{

        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        fontFamily: 'Arial, sans-serif'
      }}>
        <Navbar />
        <div>
          <Routes>
            <Route path="/employees" element={<EmployeeList />} />
            <Route path="/attendance" element={<AttendanceList />} />
            <Route path="/" element={<EmployeeList />} /> {/* Default to EmployeeList */}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
